<template>
  <Article>
    <Heading as="h1">
      <!--  -->
      Real Estate
    </Heading>
  </Article>
</template>

<script setup>
defineOptions({ name: "ViewDisclaimer" });
import Article from "../components/Article.vue";
import Heading from "../components/Heading.vue";
</script>
